import { enableProdMode, importProvidersFrom } from '@angular/core';

import { DialogModule } from '@angular/cdk/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DialogBoxService } from '@pcscol-portail/composants-pegase';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CoreModule } from './app/core/core.module';
import { EditeurModule } from './app/features/editeur/editeur.module';
import { ListModule } from './app/shared/list/list.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            // core
            CoreModule,
            // app
            AppRoutingModule,
            DialogModule,
            ListModule,
            // theme
            DialogBoxService,
            EditeurModule
        ),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        DialogBoxService,
        provideAnimations()
    ]
}).catch(err => console.log(err));
